import { CircularProgress, LinearProgress, Typography } from '@material-ui/core';

function Loader({ loading, circular }) {
  return (
    <>
      {loading ? (
        <div className="flex flex-1 flex-col items-center justify-center p-24">
          {circular ? (
            <>
              <CircularProgress color="secondary" thickness={8} size={75} />
            </>
          ) : (
            <>
              <Typography className="text-13 sm:text-16 mb-16" color="textSecondary">
                Yükleniyor...
              </Typography>
              <LinearProgress
                className="w-192 sm:w-320 max-w-full rounded-2 h-8"
                color="secondary"
              />
            </>
          )}
        </div>
      ) : null}
    </>
  );
}

export default Loader;
